import { ClaimsNormalized, Crud } from '@/models/enums'

import { Role } from "@/helpers/role";
import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);


let localUser = localStorage.getItem('user') || '{}';
if (localUser === 'undefined') {
    localUser = '{}'
}
const user = JSON.parse(localUser);
const userName = user.userName || '';
const userEmail = user.userEmail || '';
const userShortFullName = user.userShortFullName || '';
const userFullName = user.userFullName || '';
const userFullNameEn = user.userFullNameEn || '';
const userSettings = [];
const tokenExpiration = user.tokenExpiration || '';
const authToken = user.token;
const roles = user.roles || [];
const userId = user.userId || null;
const userClaims = user.userClaims || {};
const loadedLanguages = []
const defaultGridRows = 5;
const defaultGridPageSize = [5, 10, 20, 50, 100, 500];
const defaultGridPageButtonCount = 10;
const dateTimeFormat = 'dd.MM.yyyy HH:mm';
const dateTimeLongFormat = 'dd.MM.yyyy HH:mm:ss';
const dateFormat = 'dd.MM.yyyy';
const timeFormat = 'HH:mm';
const participationRequestNameEn = 'Request to participate';
const certificateStatuses = ['Завършил със сертификат', 'Graduated with a certificate'];
const fileSizeLimit = 10485760; // 10MB
const gridOptions = {
    selectable: '', // '' -> без избор / 'multiple' or 'multiple row' / 'multiple cell',
    height: 'auto',
    allowCopy: true,
    navigatable: true,
    filterable: true,
    reorderable: true,
    resizable: true,
    columnMenu: true,
    sortable: {
        mode: 'multiple',
        allowUnsort: true,
        showIndexes: true
    },
    pageable: {
        buttonCount: defaultGridPageButtonCount,
        info: true,
        type: 'numeric',
        pageSizes: defaultGridPageSize,
        pageSize: defaultGridRows,
        size: defaultGridRows,
        previousNext: true,
        refresh: true
    },
    scrollable: true,
    groupable: true
};

const evaluationCriteriaTypes = [
    { value: 1, text: 'Допустимост', textEn: 'Admissibility' },
    { value: 2, text: 'Оценка', textEn: 'Evaluation' }
];

const quotaTypes = [
    { value: 1, text: 'Апелативен район', textEn: 'Appellate region', code: 'AppellateRegion', needEventId: false },
    { value: 2, text: 'Институция', textEn: 'Institution', code: 'Institution', needEventId: false },
    { value: 3, text: 'Длъжност', textEn: 'Position', code: 'Position', needEventId: false },
    { value: 4, text: 'Професионална категория', textEn: 'Professional orientation', code: 'ProfessionalOrientation', needEventId: false },
    { value: 5, text: 'Стойност на поле', textEn: 'Field value', code: 'FieldValue', needEventId: true }
];

// {value: 5, text: 'Стойност на поле', textEn: 'Field value', code: 'FieldValue'}

const constraintTypes = [
    { value: 1, text: 'Брой участия', textEn: 'Number of participations', code: 'NumberOfParticipation', needEventId: false },
    { value: 2, text: 'Брой заявки за участие', textEn: 'Number of participation requests', code: 'NumberOfParticipationRequests', needEventId: false },
    { value: 3, text: 'Брой откази от участие', textEn: 'Number of refusals to participate', code: 'NumberOfRefusalsToParticipate', needEventId: false },
    { value: 4, text: 'Съгласие на ръководител', textEn: 'Consent of the manager', code: 'ConsentOfTheManager', needEventId: false },
    { value: 5, text: 'Участие в застъпващо се по време друго събитие', textEn: 'Participation in an overlapping event', code: 'ParticipatesInOverlappingEvent', needEventId: false },
    { value: 6, text: 'Извън целевата аудитория', textEn: 'Outside the target audience', code: 'OutsideTheTargetAudience', needEventId: false },
];

// {value: 7, text: 'Стойност на поле', textEn: 'Field value', code: 'FieldValue'}

const operators = [
    { fielTypeId: 1, text: "равно на", textEn: "is equal to", value: "eq" },
    { fielTypeId: 2, text: "равно на", textEn: "is equal to", value: "eq" },
    { fielTypeId: 3, text: "равно на", textEn: "is equal to", value: "eq" },
    { fielTypeId: 4, text: "равно на", textEn: "is equal to", value: "eq" },
    { fielTypeId: 1, text: "не е равно на", textEn: "is not equal to", value: "neq" },
    { fielTypeId: 2, text: "не е равно на", textEn: "is not equal to", value: "neq" },
    { fielTypeId: 3, text: "не е равно на", textEn: "is not equal to", value: "neq" },
    { fielTypeId: 4, text: "не е равно на", textEn: "is not equal to", value: "neq" },
    { fielTypeId: 1, text: "има стойност", textEn: "has value", value: "hasvalue" },
    { fielTypeId: 2, text: "има стойност", textEn: "has value", value: "hasvalue" },
    { fielTypeId: 3, text: "има стойност", textEn: "has value", value: "hasvalue" },
    { fielTypeId: 4, text: "има стойност", textEn: "has value", value: "hasvalue" },
    { fielTypeId: 1, text: "няма стойност", textEn: "has no value", value: "hasnovalue" },
    { fielTypeId: 2, text: "няма стойност", textEn: "has no value", value: "hasnovalue" },
    { fielTypeId: 3, text: "няма стойност", textEn: "has no value", value: "hasnovalue" },
    { fielTypeId: 4, text: "няма стойност", textEn: "has no value", value: "hasnovalue" },
    { fielTypeId: 3, text: "е по-голямо от", textEn: "is greater than", value: "gt" },
    { fielTypeId: 4, text: "е след", textEn: "is after", value: "gt" },
    { fielTypeId: 3, text: "е по-малко от", textEn: "is less than", value: "lt" },
    { fielTypeId: 4, text: "е преди", textEn: "is before", value: "gt" },
    { fielTypeId: 3, text: "е по-голямо или равно на", textEn: "is greater or equal to", value: "gte" },
    { fielTypeId: 4, text: "е след или равно на", textEn: "is after or equal to", value: "gte" },
    { fielTypeId: 3, text: "е по-малко или равно на", textEn: "is less or equal to", value: "lte" },
    { fielTypeId: 4, text: "е преди или равно на", textEn: "is before or equal to", value: "lte" },
    { fielTypeId: 2, text: "започва с", textEn: "starts with", value: "startswith" },
    { fielTypeId: 2, text: "завърва на", textEn: "ends with", value: "endswith" },
    { fielTypeId: 2, text: "съдържа", textEn: "contains", value: "contains" },
    { fielTypeId: 2, text: "не съдържа", textEn: "does not contain", value: "doesnotcontain" },
]

const personRequiredFields = {
    firstName: true,
    middleName: true,
    lastName: true,
    identificationNumber: true,
    gender: true,
    idCardNumber: false,
    idCardDateOfIssue: false,
    idCardIssuedBy: false,
    email: true,
    phone: false,
    mobilePhone: true,
    institution: true,
    education: true,
    position: true,
    positionStatistic: true
};

const isInProduction = location.href.indexOf('localhost') <= 0;

let url = '';
if (isInProduction) {
    let href = location.href.split('#')[0];
    if (href[href.length - 1] === '/') {
        href = href.slice(0, href.length - 1);
    }
    url = href;
} else {
    url = 'https://localhost:44340';
}

var hasRights = (claimType, crudType) => {
    if (!userClaims || !userClaims.hasOwnProperty(claimType)) {
        return false;
    }
    let claim = userClaims[claimType];
    if (!claim) {
        return false;
    }

    switch (crudType) {
		case 'CREATE':
			if (!claim) {
				return false;
			} else if (claim.hasOwnProperty('create')) {
                return claim.create;
            } else if (claim.hasOwnProperty('Create')) {
                return claim.Create;
            }

            return false;
		case 'READ':
			if (!claim) {
				return false;
			} else if (claim.hasOwnProperty('read')) {
                return claim.read;
            } else if (claim.hasOwnProperty('Read')) {
                return claim.Read;
            }

            return false;
		case 'UPDATE':
			if (!claim) {
				return false;
			} else if (claim.hasOwnProperty('update')) {
                return claim.update;
            } else if (claim.hasOwnProperty('Update')) {
                return claim.Update;
            }

            return false;
		case 'DELETE':
			if (!claim) {
				return false;
			} else if (claim.hasOwnProperty('delete')) {
                return claim.delete;
            } else if (claim.hasOwnProperty('Delete')) {
                return claim.Delete;
            }

            return false;
		default:
			return false;
	}
}

const userPolicies = [];
const appSigningSettings = '';

const state = {
    language: localStorage.getItem('culture') || 'bg',
    activeRoute: '',
    sidemenu: false,
    authToken: authToken,
    loggedUser: user,
    userName: userName,
    userEmail: userEmail,
    userShortFullName: userShortFullName,
    userFullName: userFullName,
    userFullNameEn: userFullNameEn,
    userSettings: userSettings,
    tokenExpiration: tokenExpiration,
    userRoles: roles,
    loadedLanguages: loadedLanguages,
    notificationDuration: 10000,
    notificationLongDuration: 120000,
    baseUrl: url,
    isInProduction: isInProduction,
    defaultGridRows: defaultGridRows,
    defaultGridPageSize: defaultGridPageSize,
    defaultGridPageButtonCount: defaultGridPageButtonCount,
    bulgariaNomId: 5251,
    sofiaNomId: 2643,
    nipCoords: [42.70039, 23.32041],
    userTasks: null,
    userStartedTasks: null,
    userOverdueTasks: null,
    userCoordinations: null,
    userOverdueCoordinations: null,
    userId: userId,
    eventNameColumnName: '���������������������������������',
    userClaims: userClaims,
    eventClaims: {},
    eventReadRights: false,
    eventEditRights: false,
    isDeveloper: roles.includes(Role.DevAdmin.toString()),
    pageTitle: '',
    pageTitleDescription: '',
    gridOptions: gridOptions,
    certificateStatuses: certificateStatuses,
    initialModel: null,
    currentModel: null,
    isEventSaved: false,
    dateTimeFormat: dateTimeFormat,
    dateTimeLongFormat: dateTimeLongFormat,
    dateFormat: dateFormat,
    timeFormat: timeFormat,
    participationRequestNameEn: participationRequestNameEn,
    currentRegister: {},
    evaluationCriteriaTypes: evaluationCriteriaTypes,
    quotaTypes: quotaTypes,
    constraintTypes: constraintTypes,
    operators: operators,
    reportingServerUrl: '',
    dropdownHeight: 500,
    fileSizeLimit: fileSizeLimit,
    nomDropdownSettings: {
        showSettings: true,
        defaultFilterPattern: 'contains',
        showNoDataTemplate: true,
        showFooterTemplate: true,
        dropdownFilterPatternOptions: [
            { value: 'startswith', text: 'Започва с', textEn: 'Starts with' },
            { value: 'endswith', text: 'Завършва на', textEn: 'Ends with' },
            { value: 'contains', text: 'Съдържа', textEn: 'constains' },
        ],
    },
    appSettings: {
        recalcSubscriptionDates: false
    },
    gridShowEllipsis: true,
    personRequiredFields: personRequiredFields,
    personEditCardRequiredFields: personRequiredFields,
    participantEditCardRequiredFields: personRequiredFields,
    tempRakingCandidateRequiredFields: personRequiredFields,
    userPolicies: userPolicies,
    dataReferencesListCount: 50,
    appSigningSettings: appSigningSettings,
    checkSignImage: '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',
    claims: {
        agenda: {
            create: hasRights(ClaimsNormalized.HallsSchedules, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.HallsSchedules, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.HallsSchedules, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.HallsSchedules, Crud.Delete) || roles.includes(Role.Nip.toString()) | roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        annualCatalog: {
            create: hasRights(ClaimsNormalized.AnnualCatalog, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.AnnualCatalog, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.AnnualCatalog, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.AnnualCatalog, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        annualCatalogProject: {
            create: hasRights(ClaimsNormalized.AnnualCatalogProject, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.AnnualCatalogProject, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.AnnualCatalogProject, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.AnnualCatalogProject, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        applicationSettings: {
            create: hasRights(ClaimsNormalized.ApplicationSettings, Crud.Create),
            read: hasRights(ClaimsNormalized.ApplicationSettings, Crud.Read),
            update: hasRights(ClaimsNormalized.ApplicationSettings, Crud.Update),
            delete: hasRights(ClaimsNormalized.ApplicationSettings, Crud.Delete),
        },
        aspNetRole: {
            create: hasRights(ClaimsNormalized.AspNetRoleAdministration, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.AspNetRoleAdministration, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.AspNetRoleAdministration, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.AspNetRoleAdministration, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        aspNetUser: {
            create: hasRights(ClaimsNormalized.AspNetUserAdministration, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.AspNetUserAdministration, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.AspNetUserAdministration, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.AspNetUserAdministration, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        audit: {
            create: hasRights(ClaimsNormalized.Audit, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Audit, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Audit, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Audit, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        auxiliaryRegister: {
            create: hasRights(ClaimsNormalized.AuxiliaryRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.AuxiliaryRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.AuxiliaryRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.AuxiliaryRegister, Crud.Delete),
        },
        auxiliaryRegisterFieldCode: {
            create: hasRights(ClaimsNormalized.AuxiliaryRegisterFieldCode, Crud.Create),
            read: hasRights(ClaimsNormalized.AuxiliaryRegisterFieldCode, Crud.Read),
            update: hasRights(ClaimsNormalized.AuxiliaryRegisterFieldCode, Crud.Update),
            delete: hasRights(ClaimsNormalized.AuxiliaryRegisterFieldCode, Crud.Delete),
        },
        calendar: {
            create: hasRights(ClaimsNormalized.Calendar, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Calendar, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Calendar, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Calendar, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        certificateAdministration: {
            create: hasRights(ClaimsNormalized.CertificateAdministration, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.CertificateAdministration, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.CertificateAdministration, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.CertificateAdministration, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        certificates: {
            create: hasRights(ClaimsNormalized.Certificates, Crud.Create),
            read: hasRights(ClaimsNormalized.Certificates, Crud.Read),
            update: hasRights(ClaimsNormalized.Certificates, Crud.Update),
            delete: hasRights(ClaimsNormalized.Certificates, Crud.Delete),
        },
        claims: {
            create: hasRights(ClaimsNormalized.Claims, Crud.Create),
            read: hasRights(ClaimsNormalized.Claims, Crud.Read),
            update: hasRights(ClaimsNormalized.Claims, Crud.Update),
            delete: hasRights(ClaimsNormalized.Claims, Crud.Delete),
        },
        claimsAdministration: {
            create: hasRights(ClaimsNormalized.ClaimsAdministration, Crud.Create),
            read: hasRights(ClaimsNormalized.ClaimsAdministration, Crud.Read),
            update: hasRights(ClaimsNormalized.ClaimsAdministration, Crud.Update),
            delete: hasRights(ClaimsNormalized.ClaimsAdministration, Crud.Delete),
        },
        company: {
            create: hasRights(ClaimsNormalized.Company, Crud.Create),
            read: hasRights(ClaimsNormalized.Company, Crud.Read),
            update: hasRights(ClaimsNormalized.Company, Crud.Update),
            delete: hasRights(ClaimsNormalized.Company, Crud.Delete),
        },
        coordinationsAdministration: {
            create: hasRights(ClaimsNormalized.CoordinationsAdministration, Crud.Create),
            read: hasRights(ClaimsNormalized.CoordinationsAdministration, Crud.Read),
            update: hasRights(ClaimsNormalized.CoordinationsAdministration, Crud.Update),
            delete: hasRights(ClaimsNormalized.CoordinationsAdministration, Crud.Delete),
        },
        dataReferences: {
            create: hasRights(ClaimsNormalized.DataReferences, Crud.Create),
            read: hasRights(ClaimsNormalized.DataReferences, Crud.Read),
            update: hasRights(ClaimsNormalized.DataReferences, Crud.Update),
            delete: hasRights(ClaimsNormalized.DataReferences, Crud.Delete),
        },
        deletedRecords: {
            create: hasRights(ClaimsNormalized.DeletedRecords, Crud.Create),
            read: hasRights(ClaimsNormalized.DeletedRecords, Crud.Read),
            update: hasRights(ClaimsNormalized.DeletedRecords, Crud.Update),
            delete: hasRights(ClaimsNormalized.DeletedRecords, Crud.Delete),
        },
        documents: {
            create: hasRights(ClaimsNormalized.Documents, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Documents, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Documents, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Documents, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        dynamicRegister: {
            create: hasRights(ClaimsNormalized.DynamicRegister, Crud.Create) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.DynamicRegister, Crud.Read) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.DynamicRegister, Crud.Update) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.DynamicRegister, Crud.Delete) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        email: {
            create: hasRights(ClaimsNormalized.Email, Crud.Create),
            read: hasRights(ClaimsNormalized.Email, Crud.Read),
            update: hasRights(ClaimsNormalized.Email, Crud.Update),
            delete: hasRights(ClaimsNormalized.Email, Crud.Delete),
        },
        evaluation: {
            create: hasRights(ClaimsNormalized.Evaluation, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Evaluation, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Evaluation, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Evaluation, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        evaluationCriteria: {
            create: hasRights(ClaimsNormalized.EvaluationCriteria, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EvaluationCriteria, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EvaluationCriteria, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EvaluationCriteria, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        event: {
            create: hasRights(ClaimsNormalized.Event, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Event, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Event, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Event, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        eventAgenda: {
            create: hasRights(ClaimsNormalized.EventAgenda, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventAgenda, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventAgenda, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventAgenda, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        eventBudget: {
            create: hasRights(ClaimsNormalized.EventBudget, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventBudget, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventBudget, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventBudget, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        eventCosts: {
            create: hasRights(ClaimsNormalized.EventCosts, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventCosts, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventCosts, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventCosts, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        eventDetails: {
            create: hasRights(ClaimsNormalized.EventDetails, Crud.Create),
            read: hasRights(ClaimsNormalized.EventDetails, Crud.Read),
            update: hasRights(ClaimsNormalized.EventDetails, Crud.Update),
            delete: hasRights(ClaimsNormalized.EventDetails, Crud.Delete),
        },
        eventFormManagement: {
            create: hasRights(ClaimsNormalized.EventFormManagement, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventFormManagement, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventFormManagement, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventFormManagement, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        eventParticipantManagement: {
            create: hasRights(ClaimsNormalized.EventParticipantManagement, Crud.Create) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventParticipantManagement, Crud.Read) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventParticipantManagement, Crud.Update) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventParticipantManagement, Crud.Delete) || roles.includes(Role.Admin.toString()),
        },
        eventReport: {
            create: hasRights(ClaimsNormalized.EventReport, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventReport, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventReport, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventReport, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        eventSubscriptions: {
            create: hasRights(ClaimsNormalized.EventSubscriptions, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.EventSubscriptions, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.EventSubscriptions, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.EventSubscriptions, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        externalServices: {
            create: hasRights(ClaimsNormalized.ExternalServices, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.ExternalServices, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.ExternalServices, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.ExternalServices, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        financialControl: {
            create: hasRights(ClaimsNormalized.FinancialControl, Crud.Create) || roles.includes(Role.FinancialControl.toString()),
            read: hasRights(ClaimsNormalized.FinancialControl, Crud.Read) || roles.includes(Role.FinancialControl.toString()),
            update: hasRights(ClaimsNormalized.FinancialControl, Crud.Update) || roles.includes(Role.FinancialControl.toString()),
            delete: hasRights(ClaimsNormalized.FinancialControl, Crud.Delete) || roles.includes(Role.FinancialControl.toString()),
        },
        formSurvey: {
            create: hasRights(ClaimsNormalized.FormSurvey, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.FormSurvey, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.FormSurvey, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.FormSurvey, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        formSurveyEntity: {
            create: hasRights(ClaimsNormalized.FormSurveyEntity, Crud.Create) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.FormSurveyEntity, Crud.Read) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.FormSurveyEntity, Crud.Update) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.FormSurveyEntity, Crud.Delete) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        formSurveyTemplate: {
            create: hasRights(ClaimsNormalized.FormSurveyTemplate, Crud.Create),
            read: hasRights(ClaimsNormalized.FormSurveyTemplate, Crud.Read),
            update: hasRights(ClaimsNormalized.FormSurveyTemplate, Crud.Update),
            delete: hasRights(ClaimsNormalized.FormSurveyTemplate, Crud.Delete),
        },
        formSecurity: {
            create: hasRights(ClaimsNormalized.FormSecurity, Crud.Create),
            read: hasRights(ClaimsNormalized.FormSecurity, Crud.Read),
            update: hasRights(ClaimsNormalized.FormSecurity, Crud.Update),
            delete: hasRights(ClaimsNormalized.FormSecurity, Crud.Delete),
        },
        forum: {
            create: hasRights(ClaimsNormalized.Forum, Crud.Create) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Forum, Crud.Read) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Forum, Crud.Update) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Forum, Crud.Delete) || roles.includes(Role.VerifiedUser.toString()) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        formFieldCode: {
            create: hasRights(ClaimsNormalized.FormFieldCode, Crud.Create),
            read: hasRights(ClaimsNormalized.FormFieldCode, Crud.Read),
            update: hasRights(ClaimsNormalized.FormFieldCode, Crud.Update),
            delete: hasRights(ClaimsNormalized.FormFieldCode, Crud.Delete),
        },
        help: {
            create: hasRights(ClaimsNormalized.Help, Crud.Create),
            read: hasRights(ClaimsNormalized.Help, Crud.Read),
            update: hasRights(ClaimsNormalized.Help, Crud.Update),
            delete: hasRights(ClaimsNormalized.Help, Crud.Delete),
        },
        localization: {
            create: hasRights(ClaimsNormalized.Localization, Crud.Create),
            read: hasRights(ClaimsNormalized.Localization, Crud.Read),
            update: hasRights(ClaimsNormalized.Localization, Crud.Update),
            delete: hasRights(ClaimsNormalized.Localization, Crud.Delete),
        },
        lecturer: {
            create: hasRights(ClaimsNormalized.Lecturer, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Lecturer, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Lecturer, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Lecturer, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        lecturersElRegister: {
            create: hasRights(ClaimsNormalized.LecturersElRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.LecturersElRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.LecturersElRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.LecturersElRegister, Crud.Delete),
        },
        qesLocalServer: {
            create: hasRights(ClaimsNormalized.QESLocalServer, Crud.Create),
            read: hasRights(ClaimsNormalized.QESLocalServer, Crud.Read),
            update: hasRights(ClaimsNormalized.QESLocalServer, Crud.Update),
            delete: hasRights(ClaimsNormalized.QESLocalServer, Crud.Delete),
        },
        mentor: {
            create: hasRights(ClaimsNormalized.Mentor, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Mentor, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Mentor, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Mentor, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        nijData: {
            create: hasRights(ClaimsNormalized.NijData, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.NijData, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.NijData, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.NijData, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        nijEmployee: {
            create: hasRights(ClaimsNormalized.NijEmployee, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.NijEmployee, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.NijEmployee, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.NijEmployee, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        nomenclature: {
            create: hasRights(ClaimsNormalized.Nomenclature, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Nomenclature, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Nomenclature, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Nomenclature, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        nomenclatureTypes: {
            create: hasRights(ClaimsNormalized.NomenclatureTypes, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.NomenclatureTypes, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.NomenclatureTypes, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.NomenclatureTypes, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        notifications: {
            create: hasRights(ClaimsNormalized.Notifications, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Notifications, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Notifications, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Notifications, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        notificationSubscriptionWithActivationOfParticipationRequest: {
            create: hasRights(ClaimsNormalized.NotificationSubscriptionWithActivationOfParticipationRequest, Crud.Create),
            read: hasRights(ClaimsNormalized.NotificationSubscriptionWithActivationOfParticipationRequest, Crud.Read),
            update: hasRights(ClaimsNormalized.NotificationSubscriptionWithActivationOfParticipationRequest, Crud.Update),
            delete: hasRights(ClaimsNormalized.NotificationSubscriptionWithActivationOfParticipationRequest, Crud.Delete),
        },
        organizationalCalendar: {
            create: hasRights(ClaimsNormalized.OrganizationalCalendar, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.OrganizationalCalendar, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.OrganizationalCalendar, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.OrganizationalCalendar, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        organizationalModel: {
            create: hasRights(ClaimsNormalized.OrganizationalModel, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.OrganizationalModel, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.OrganizationalModel, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.OrganizationalModel, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        participant: {
            create: hasRights(ClaimsNormalized.Participant, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Participant, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Participant, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Participant, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        person: {
            create: hasRights(ClaimsNormalized.Person, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Person, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Person, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Person, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        presence: {
            create: hasRights(ClaimsNormalized.Presence, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Presence, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Presence, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Presence, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        planning: {
            create: hasRights(ClaimsNormalized.Planning, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Planning, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Planning, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Planning, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        rankingCriteria: {
            create: hasRights(ClaimsNormalized.RankingCriteria, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.RankingCriteria, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.RankingCriteria, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.RankingCriteria, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        releaseInfo: {
            create: hasRights(ClaimsNormalized.ReleaseInfo, Crud.Create) || roles.includes(Role.DevAdmin.toString()),
			read: hasRights(ClaimsNormalized.ReleaseInfo, Crud.Read) || roles.includes(Role.DevAdmin.toString()),
			update: hasRights(ClaimsNormalized.ReleaseInfo, Crud.Update) || roles.includes(Role.DevAdmin.toString()),
			delete: hasRights(ClaimsNormalized.ReleaseInfo, Crud.Delete) || roles.includes(Role.DevAdmin.toString()),
        },
        registers: {
            create: hasRights(ClaimsNormalized.Registers, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Registers, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Registers, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Registers, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        registerFieldCode: {
            create: hasRights(ClaimsNormalized.RegisterFieldCode, Crud.Create),
            read: hasRights(ClaimsNormalized.RegisterFieldCode, Crud.Read),
            update: hasRights(ClaimsNormalized.RegisterFieldCode, Crud.Update),
            delete: hasRights(ClaimsNormalized.RegisterFieldCode, Crud.Delete),
        },
        reports: {
            create: hasRights(ClaimsNormalized.Reports, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Reports, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Reports, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Reports, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        reportsData: {
            create: hasRights(ClaimsNormalized.ReportsData, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.ReportsData, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.ReportsData, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.ReportsData, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        tariff: {
            create: hasRights(ClaimsNormalized.Tariff, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Tariff, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Tariff, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Tariff, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.Admin.toString()),
        },
        tasks: {
            create: hasRights(ClaimsNormalized.Tasks, Crud.Create) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.Tasks, Crud.Read) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.Tasks, Crud.Update) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.Tasks, Crud.Delete) || roles.includes(Role.Nip.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        tasksAdministration: {
            create: hasRights(ClaimsNormalized.TasksAdministration, Crud.Create),
            read: hasRights(ClaimsNormalized.TasksAdministration, Crud.Read),
            update: hasRights(ClaimsNormalized.TasksAdministration, Crud.Update),
            delete: hasRights(ClaimsNormalized.TasksAdministration, Crud.Delete),
        },
        tempRanking: {
            create: hasRights(ClaimsNormalized.TempRanking, Crud.Create) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            read: hasRights(ClaimsNormalized.TempRanking, Crud.Read) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            update: hasRights(ClaimsNormalized.TempRanking, Crud.Update) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
            delete: hasRights(ClaimsNormalized.TempRanking, Crud.Delete) || roles.includes(Role.EventAdmin.toString()) || roles.includes(Role.RegisterAdmin.toString()) || roles.includes(Role.Admin.toString()),
        },
        upcomingEvent: {
            create: hasRights(ClaimsNormalized.UpcomingEvent, Crud.Create),
            read: hasRights(ClaimsNormalized.UpcomingEvent, Crud.Read),
            update: hasRights(ClaimsNormalized.UpcomingEvent, Crud.Update),
            delete: hasRights(ClaimsNormalized.UpcomingEvent, Crud.Delete),
        },
        uninformedParticipants: {
            create: hasRights(ClaimsNormalized.UninformedParticipants, Crud.Create),
            read: hasRights(ClaimsNormalized.UninformedParticipants, Crud.Read),
            update: hasRights(ClaimsNormalized.UninformedParticipants, Crud.Update),
            delete: hasRights(ClaimsNormalized.UninformedParticipants, Crud.Delete),
        },
        hangfire: {
            create: roles.includes(Role.SuperAdmin.toString()),
            read: roles.includes(Role.SuperAdmin.toString()),
            update: roles.includes(Role.SuperAdmin.toString()),
            delete: roles.includes(Role.SuperAdmin.toString()),
        },
        upcomingEventsPanelDescription: {
            create: hasRights(ClaimsNormalized.UpcomingEventsPanelDescription, Crud.Create),
            read: hasRights(ClaimsNormalized.UpcomingEventsPanelDescription, Crud.Read),
            update: hasRights(ClaimsNormalized.UpcomingEventsPanelDescription, Crud.Update),
            delete: hasRights(ClaimsNormalized.UpcomingEventsPanelDescription, Crud.Delete),
        },
        institutionsRegister: {
            create: hasRights(ClaimsNormalized.InstitutionsRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.InstitutionsRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.InstitutionsRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.InstitutionsRegister, Crud.Delete),
        },
        participantWithPerson: {
            create: hasRights(ClaimsNormalized.ParticipantWithPerson, Crud.Create),
            read: hasRights(ClaimsNormalized.ParticipantWithPerson, Crud.Read),
            update: hasRights(ClaimsNormalized.ParticipantWithPerson, Crud.Update),
            delete: hasRights(ClaimsNormalized.ParticipantWithPerson, Crud.Delete),
        },
        organizersRegister: {
            create: hasRights(ClaimsNormalized.OrganizersRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.OrganizersRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.OrganizersRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.OrganizersRegister, Crud.Delete),
        },
        venuesRegister: {
            create: hasRights(ClaimsNormalized.VenuesRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.VenuesRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.VenuesRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.VenuesRegister, Crud.Delete),
        },
        accommodationPlacesRegister: {
            create: hasRights(ClaimsNormalized.AccommodationPlacesRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.AccommodationPlacesRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.AccommodationPlacesRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.AccommodationPlacesRegister, Crud.Delete),
        },
        projectsRegister: {
            create: hasRights(ClaimsNormalized.ProjectsRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.ProjectsRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.ProjectsRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.ProjectsRegister, Crud.Delete),
        },
        publicOrdersRegister: {
            create: hasRights(ClaimsNormalized.PublicOrdersRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.PublicOrdersRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.PublicOrdersRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.PublicOrdersRegister, Crud.Delete),
        },
        activitiesRegister: {
            create: hasRights(ClaimsNormalized.ActivitiesRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.ActivitiesRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.ActivitiesRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.ActivitiesRegister, Crud.Delete),
        },
        thematicAreasRegister: {
            create: hasRights(ClaimsNormalized.ThematicAreasRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.ThematicAreasRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.ThematicAreasRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.ThematicAreasRegister, Crud.Delete),
        },
        eventThemesRegister: {
            create: hasRights(ClaimsNormalized.EventThemesRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.EventThemesRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.EventThemesRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.EventThemesRegister, Crud.Delete),
        },
        nijPositionsRegister: {
            create: hasRights(ClaimsNormalized.NijPositionsRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.NijPositionsRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.NijPositionsRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.NijPositionsRegister, Crud.Delete),
        },
        contractsRegister: {
            create: hasRights(ClaimsNormalized.ContractsRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.ContractsRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.ContractsRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.ContractsRegister, Crud.Delete),
        },
        organizationalModelsRegister: {
            create: hasRights(ClaimsNormalized.OrganizationalModelsRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.OrganizationalModelsRegister, Crud.Read),
            update: hasRights(ClaimsNormalized.OrganizationalModelsRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.OrganizationalModelsRegister, Crud.Delete),
        },
        rankingCriteriaRegister: {
            create: hasRights(ClaimsNormalized.RankingCriteriaRegister, Crud.Create),
            read: hasRights(ClaimsNormalized.RankingCriteriaReappSettingsgister, Crud.Read),
            update: hasRights(ClaimsNormalized.RankingCriteriaRegister, Crud.Update),
            delete: hasRights(ClaimsNormalized.RankingCriteriaRegister, Crud.Delete),
        },
        signingAdministration: {
            create: hasRights(ClaimsNormalized.SigningAdministration, Crud.Create),
            read: hasRights(ClaimsNormalized.SigningAdministration, Crud.Read),
            update: hasRights(ClaimsNormalized.SigningAdministration, Crud.Update),
            delete: hasRights(ClaimsNormalized.SigningAdministration, Crud.Delete),
        },
        signingProcedureFiling: {
            create: hasRights(ClaimsNormalized.SigningProcedureFiling, Crud.Create),
            read: hasRights(ClaimsNormalized.SigningProcedureFiling, Crud.Read),
            update: hasRights(ClaimsNormalized.SigningProcedureFiling, Crud.Update),
            delete: hasRights(ClaimsNormalized.SigningProcedureFiling, Crud.Delete),
        },
    },
    allowParticipantsSoftDelete: false,
    allowLecturersSoftDelete: false
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
});
